module.exports = __webpack_public_path__ + "img/yuejincun.1912ba93.png";